import { render, staticRenderFns } from "./ConfigurationsList.vue?vue&type=template&id=46401fb5&"
import script from "./ConfigurationsList.vue?vue&type=script&lang=js&"
export * from "./ConfigurationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports